
function Unauth () {
    return (
        <div className="unauth-container">
            <div className="unauthorized">
                <h3>Access Denied</h3>
                <h5>Please log in through the NORM Community link to view the archives</h5>
                <ol>
                    <li className="login-instructions">Log into the <a target="_blank" href="https://norm.glueup.com/account/login/">Norm Community</a></li>
                    <li className="login-instructions">Go to the <a  target="_blank" href="https://norm.glueup.com/my/community/4003">Norm Connect Forum</a></li>
                    <li className="login-instructions">Click on the pinned link</li>
                    <li className="login-instructions">You will be logged in thereafter</li>
                    <li className="login-instructions">If you clear your session data in your browser you may need to log in again.</li>
                </ol>

                
            </div>
        </div>
    )
}


export default Unauth;